import { createFileRoute, redirect } from "@tanstack/react-router";
import { getEditorRedirect } from "@/features/store-editor/records";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/$coworld/preview_/edit")({
  beforeLoad: async ({ location, abortController }) => {
    const href = await getEditorRedirect({
      data: { href: location.href },
      signal: abortController.signal,
    });
    throw redirect({ href, statusCode: 307 });
  },
  pendingComponent: () => <CommunityPageLoading title="Storefront editor" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
});
